import Color from "color";
import React from "react";
import cardStyles from "./cardStyles";
import { createUseStyles } from "react-jss";
import { mergeDeepRight } from "ramda";

const MAX_TEXT_LINES = 4;
const TEXT_LINE_HEIGHT = 17;
const TEXT_MAX_HEIGHT = TEXT_LINE_HEIGHT * MAX_TEXT_LINES;

const useStyles = createUseStyles((theme) =>
  mergeDeepRight(cardStyles, {
    contentWrapper: {
      height: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "start",
    },
    imageWrapper: { height: "145px", width: "100%" },
    image: {
      width: "100%",
      height: "100%",
      borderRadius: "2px",
      backgroundSize: "contain",
      backgroundPosition: "center center",
      backgroundRepeat: "no-repeat",
    },
    textWrapper: {
      width: "100%",
    },
    priceBadgeWrapper: {
      position: "absolute",
      left: 0,
      top: 0,
      height: "21px",
      maxWidth: "50%",
      padding: "4px 4px 4px 4px",
      border: "0",
      borderRadius: "2px",
      color: "#ffffff",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: theme.secondaryColor,
    },
    priceText: { composes: "$singleLineEllipsis" },
    badgesRow: {
      width: "100%",
      display: "flex",
      justifyContent: "flex-start",
      flexWrap: "wrap",
    },
    badgeWrapper: {
      height: "21px",
      maxWidth: "100%",
      marginRight: "5px",
      padding: "0 5px 0 5px",
      border: "0",
      borderRadius: "2px",
      color: theme.secondaryColor,
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: Color(theme.secondaryColor).alpha(0.1).string(),
    },
    badgeText: {
      composes: "$singleLineEllipsis",
      fontSize: "13px",
      lineHeight: "16px",
    },
    title: {
      composes: "$singleLineEllipsis",
      color: theme.cardTextColor,
      fontStyle: "normal",
      fontSize: "16px",
      fontWeight: "500",
      lineHeight: "18px",
      marginBottom: "3px",
      cursor: "pointer",
    },
    text: {
      composes: "$multilineEllipsis",
      "-webkit-line-clamp": `${MAX_TEXT_LINES}`,
      maxHeight: `${TEXT_MAX_HEIGHT}px`,
      lineHeight: `${TEXT_LINE_HEIGHT}px`,
      color: theme.cardTextColorSecondary,
      fontSize: "13px",
      whiteSpace: "pre-line",
    },
  })
);

export default ({ result }) => {
  const styles = useStyles();
  return (
    <div className={styles.contentWrapper}>
      {result.price && (
        <div className={styles.priceBadgeWrapper}>
          <div className={styles.priceText}>{result.price}</div>
        </div>
      )}
      <div className={styles.imageWrapper}>
        <div
          className={styles.image}
          style={{
            backgroundImage: `url("${result.imageUrl}")`,
          }}
        />
      </div>
      <div className={styles.textWrapper}>
        <div className={styles.title}>{result.title}</div>
        <div className={styles.text}>{result.text}</div>
      </div>
      <div className={styles.badgesRow}>
        {result.tags.map((badgeText, i) => (
          <div className={styles.badgeWrapper} key={i}>
            <div className={styles.badgeText}>{badgeText}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
